import { render, staticRenderFns } from "./CustomImage.vue?vue&type=template&id=05bc4990"
import script from "./CustomImage.vue?vue&type=script&lang=ts"
export * from "./CustomImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports